"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
export default function ContactAndSidebarForm() {
  return;
}
function SidebarContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-lg border border-green-200 bg-green-50 p-6 text-center">
        <p className="mb-4 text-green-800">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="w-full">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-2">
      <FormField control={control} name="name" rules={{
      required: "Name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Name & Surname</FormLabel>
            <FormControl>
              <Input placeholder="NAME & SURNAME" className="border-muted-foreground/30 bg-white" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Email Address</FormLabel>
            <FormControl>
              <Input type="email" placeholder="EMAIL ADDRESS" className="border-muted-foreground/30 bg-white" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" rules={{
      required: "Contact number is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Contact Number</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="CONTACT NUMBER" className="border-muted-foreground/30 bg-white" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="sr-only">Message</FormLabel>
            <FormControl>
              <Textarea placeholder="MESSAGE" className="min-h-[120px] resize-none border-muted-foreground/30 bg-white" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="rounded-md bg-destructive/10 p-3 text-sm text-destructive">
          {submitError}
        </div>}

      <div className="pt-2 text-right">
        <Button type="submit" disabled={isSubmitting} variant="outline" className="min-w-[100px] border-muted-foreground/30 bg-white hover:bg-muted">
          {isSubmitting ? <>
              <Loader className="mr-2 size-4 animate-spin" />
              SENDING...
            </> : "SUBMIT"}
        </Button>
      </div>
    </Form>;
}